"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var draft_js_1 = require("draft-js");
var wagtailConfig_1 = require("../../../config/wagtailConfig");
var MAX_EDITOR_RELOADS = 3;
var EditorFallback = /** @class */ (function (_super) {
    __extends(EditorFallback, _super);
    function EditorFallback(props) {
        var _this = _super.call(this, props) || this;
        var field = props.field;
        _this.state = {
            error: null,
            info: null,
            reloads: 0,
            showContent: false,
            showError: false,
            initialContent: field.value,
        };
        _this.renderError = _this.renderError.bind(_this);
        _this.toggleContent = _this.toggleContent.bind(_this);
        _this.toggleError = _this.toggleError.bind(_this);
        _this.onReloadEditor = _this.onReloadEditor.bind(_this);
        return _this;
    }
    EditorFallback.prototype.componentDidCatch = function (error, info) {
        var field = this.props.field;
        var initialContent = this.state.initialContent;
        this.setState({ error: error, info: info });
        field.value = initialContent;
    };
    EditorFallback.prototype.onReloadEditor = function () {
        var reloads = this.state.reloads;
        this.setState({
            error: null,
            info: null,
            reloads: reloads + 1,
            showContent: false,
            showError: false,
        });
    };
    EditorFallback.prototype.toggleContent = function () {
        var showContent = this.state.showContent;
        this.setState({ showContent: !showContent });
    };
    EditorFallback.prototype.toggleError = function () {
        var showError = this.state.showError;
        this.setState({ showError: !showError });
    };
    EditorFallback.prototype.renderError = function () {
        var field = this.props.field;
        var _a = this.state, error = _a.error, info = _a.info, reloads = _a.reloads, showContent = _a.showContent, showError = _a.showError;
        var content = field.rawContentState &&
            draft_js_1.convertFromRaw(field.rawContentState).getPlainText();
        return (react_1["default"].createElement("div", { className: "Draftail-Editor" },
            react_1["default"].createElement("div", { className: "Draftail-Toolbar" },
                content && (react_1["default"].createElement("button", { type: "button", className: "Draftail-ToolbarButton", onClick: this.toggleContent }, wagtailConfig_1.STRINGS.SHOW_LATEST_CONTENT)),
                react_1["default"].createElement("button", { type: "button", className: "Draftail-ToolbarButton", onClick: this.toggleError }, wagtailConfig_1.STRINGS.SHOW_ERROR),
                reloads < MAX_EDITOR_RELOADS ? (react_1["default"].createElement("button", { type: "button", className: "Draftail-ToolbarButton", onClick: this.onReloadEditor }, wagtailConfig_1.STRINGS.RELOAD_EDITOR)) : (react_1["default"].createElement("button", { type: "button", className: "Draftail-ToolbarButton", onClick: function () { return window.location.reload(false); } }, wagtailConfig_1.STRINGS.RELOAD_PAGE))),
            react_1["default"].createElement("div", { className: "DraftEditor-root" },
                react_1["default"].createElement("div", { className: "public-DraftEditor-content" },
                    react_1["default"].createElement("div", { className: "public-DraftEditorPlaceholder-inner" },
                        wagtailConfig_1.STRINGS.EDITOR_CRASH,
                        showContent && (react_1["default"].createElement("textarea", { className: "EditorFallback__textarea", value: content, readOnly: true })),
                        showError && (react_1["default"].createElement("pre", { className: "help-block help-critical" },
                            react_1["default"].createElement("code", { className: "EditorFallback__error" }, error.name + ": " + error.message + "\n\n" + error.stack + "\n" + info.componentStack))))))));
    };
    EditorFallback.prototype.render = function () {
        var children = this.props.children;
        var error = this.state.error;
        return error ? this.renderError() : children;
    };
    return EditorFallback;
}(react_1.PureComponent));
EditorFallback.propTypes = {
    children: prop_types_1["default"].node.isRequired,
    field: prop_types_1["default"].object.isRequired,
};
exports["default"] = EditorFallback;
